import { Address } from '@pelicargo/types';

import { isoCountryFallback, isoStateFallback, join } from '..';

export const prettyAddress = (address: Address) => {
  return [
    address?.recipient,
    address?.line_one,
    address?.line_two,
    join([
      address?.city,
      isoStateFallback(address?.state || ''),
      address?.zip_code,
      isoCountryFallback(address?.country || ''),
    ]),
  ]
    .filter(Boolean)
    .join('\n');
};
